/**
 * Shared state between <HelpIcon> (anywhere on a page) and the layout-mounted
 * <HelpFlyover>.
 *
 * Module-level on purpose: there is one flyover per surface and the icon can
 * sit arbitrarily deep in a page, so prop-drilling or provide/inject through
 * every layout would be a redesign. This is the whole mechanism:
 *
 *   - HelpIcon calls `openHelpFlyoverAt(target)`: records the target and
 *     raises `open`.
 *   - The layout watches `open` and flips its own `helpFlyoverOpen` (the
 *     layout's Help button keeps working exactly as before).
 *   - HelpFlyover reads `target`; if its audience matches the flyover's, the
 *     target replaces the route-derived path. Mismatches are ignored there.
 *   - HelpFlyover calls `closeHelpFlyover()` on every close, clearing both,
 *     so the next plain Help click is route-contextual again.
 */
import { reactive } from "vue";

export const helpFlyoverState = reactive({
    /** An icon asked for the flyover. Layouts mirror this into their own open flag. */
    open: false,
    /** { audience, slug, heading } or null. */
    target: null,
});

export function openHelpFlyoverAt({ audience, slug, heading }) {
    helpFlyoverState.target = { audience, slug, heading };
    helpFlyoverState.open = true;
}

export function closeHelpFlyover() {
    helpFlyoverState.open = false;
    helpFlyoverState.target = null;
}
